<template>
  <div class="lazer">
    <img src="@/assets/promo/lazer_promo.png" alt="Atomic Lazerball" class="promo">
    <a href="https://www.amazon.com/Atomic-LazerBall-Kindle-Tablet-Edition/dp/B00DKD4X4I/ref=sr_1_1?dchild=1&qid=1598738759&refinements=p_4%3ACreated+By+Intelligent+Design&s=mobile-apps&search-type=ss&sr=1-1">
      <img src="@/assets/buttons/amazon-kindlefire-white_badge.png" alt="">
    </a>
    <br><br>
    <h2>Orbital Gravity Meets Pinball Action!</h2>
    <br>
    <p class="app-blurb">Control the spin to keep the lazerball from being lost in the void. Be sure to earn
      Superballs to destroy containment field generators!
    </p>
    <br><br>
    <iframe
      src="https://www.youtube.com/embed/y_87n646DKo"
      frameborder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
      :style="embedHeight"></iframe>
    <img src="@/assets/screenshots/atomic_01.png" alt="">
    <img src="@/assets/screenshots/atomic_02.png" alt="">
    <img src="@/assets/screenshots/atomic_03.png" alt="">
    <img src="@/assets/screenshots/atomic_04.png" alt="">
  </div>
</template>

<script>
export default {
  name: 'Lazer',
  computed: {
    factor () {
      return window.innerWidth / 1280
    },
    embedHeight () {
      return {
        height: 566 * this.factor + 'px'
      }
    }
  }
}
</script>

<style scoped>
.lazer {
  background-color: cornflowerblue;
  color: white;
  font-weight: 800;
  font-size: 1.2em;
}
.lazer img {
  margin: 0 10px;
}
.promo {
  margin: 0 !important;
  width: 100%;
}

h2 {
  width: 80%;
  margin: auto;
}
iframe {
  width: 100%;
}
</style>
